
ADILF.define('adilf/util/config-validator',['require','exports','module','streamhub-sdk/jquery','adilf/util/markup-to-config','adilf/debug','adilf/context'],function (require, exports, module) {/* Utility: Config validator */
/* validates el, parses markup from el, creates Debug, autoStart, enforces required values */
"use strict";

var jquery = require('streamhub-sdk/jquery');
var MarkupToConfig = require('adilf/util/markup-to-config');
var Debug = require('adilf/debug');
var Context = require('adilf/context');

module.exports = function(args) {
    var self = this;
    self.conf = self.conf || {};

    self.conf.autoStart = (self.conf.autoStart === false) ? false : true;
    self.conf.name = self.conf.name || args.app + "_"+ Math.floor(Math.random() * 1000);
    self.debug = new Debug(args.app + " (" + self.conf.name + ")");

    if(!self.conf.el && 'defaultEl' in args) {
        self.conf.el = args.defaultEl;
    }
    if(typeof self.conf.el === 'string') {
        if(document.getElementById(self.conf.el)) {
            self.conf.el = document.getElementById(self.conf.el);
        } else {
            self.debug.warn("Element '#" + self.conf.el + "' not found, aborting");
            return false;
        }
    }
    self.conf = jquery.extend(self.conf, MarkupToConfig.parse(self.conf.el));

    self.conf.$el = jquery(self.conf.el);

    if(args.required) {
        for(var i=0; i<args.required.length; i++) {
            if(typeof self.conf[args.required[i]] === 'undefined') {
                self.debug.warn(args.required[i] + " required, aborting");
                return false;
            }
        }
    }

    // Reset context according to networkId from config if necessary
    if(self.conf.networkId && self.conf.networkId != Context.getNetworkId()) {
        self.debug.warn("App config has different networkId ("+self.conf.networkId+") from present context ("+Context.getNetworkId()+"); resetting to " + self.conf.networkId);
        Context.reset({'networkId':self.conf.networkId});
        self.conf.siteId = Context.getSiteId();
    }

    self.debug.print("Config validated", self.conf);
    return true;
};
});
